import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Select, Checkbox, MenuComponent, Loading, InputTags } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Card, CardContent, Grid, Icon, IconButton } from '@mui/material'

//Views
import CreateEditUnitTypeEvent from "../createEditUnitTypeEvent"
import DeleteUnitTypeEvent from "../deleteUnitTypeEvent"

//Security
import { HasPermission } from "Core/security";

//Actions
import {
    clearRedux,
    searchEntityRequest,
    searchUnitTypeEventsRequest,
    unitTypeEventCreateEditOpenModal,
    unitTypeEventDeleteOpenModal,
} from 'Redux/actions';

//Styles
import './index.scss';

const UnitTypeEventsList = (props) => {
    const { event, eventId, from, manufacturerId, manufacturerParam, unitTypeParam, unitTypeId } = props
    const { manufacturers, unitTypes } = useSelector(state => state.generalRedux);
    const CreateEditUnitTypeEventOpenModal = useSelector(state => state.createEditUnitTypeEventRedux.openModal);
    const DeleteUnitTypeEventOpenModal = useSelector(state => state.deleteUnitTypeEventRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);

    const { messages } = useIntl();
    const dispatch = useDispatch();

    const [manufacturer, setManufacturer] = useState(null)
    const [selectedItems, setSelectedItems] = useState([])
    const [tags, setTags] = useState([])
    const [valueSearch, setValueSearch] = useState("")


    const {
        loading,
        unitTypeEvents,
    } = useSelector(state => state.unitTypeEventsRedux);

    const loadData = (select, manParam, tagsParam) => {
        setSelectedItems([])
        let payload = []
        if (from === "events") {
            payload = [{ fields: 'eventId', terms: [eventId], exact: true, conditionOperator: "AND" }]
            if (select) {
                manParam && payload.push({ fields: 'unitType_manufacturerId', terms: [manParam.id], exact: true, conditionOperator: "AND" })
            } else if (manufacturer) {
                payload.push({ fields: 'unitType_manufacturerId', terms: [manufacturer.id], exact: true, conditionOperator: "AND" })
            }

        } else if (from === "manufacturer") {
            payload = [{ fields: 'unitType_manufacturerId', terms: [manufacturerId], exact: true, conditionOperator: "AND" }]
            payload.push({ fields: 'unitType_Id', terms: [unitTypeParam.id], exact: true, conditionOperator: "AND" })
            if (select) {
                if (tagsParam?.length > 0)
                    payload.push({ fields: 'event_name', terms: tagsParam, exact: false, conditionOperator: "OR" })
            } else if (tags?.length > 0) {
                payload.push({ fields: 'event_name', terms: tags, exact: false, conditionOperator: "OR" })
            }
        }

        dispatch(searchUnitTypeEventsRequest(payload))
    }

    useEffect(() => {

        loadData();
        (!manufacturers || manufacturers?.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }));
        (!unitTypes || unitTypes?.length === 0) && dispatch(searchEntityRequest({ key: "unitTypes" }));
    }, [])

    //Clear
    useEffect(() => {
        return () => {
            dispatch(clearRedux("UNIT_TYPE_EVENTS"))
            setManufacturer(null)
            setTags([])
            setValueSearch("")
        }
    }, [])

    return (
        <Grid container
            direction='row'
            justifyContent='space-between'
            alignItems='center'>
            {loading && <Loading overlay show />}
            <Grid item xs={8}>
                {
                    from === "events" &&
                    <Select
                        id="manufactures"
                        label={messages['unit_type_events_list_manufaturers']}
                        value={manufacturers && manufacturers.length > 0 && manufacturers.find(x => x.id === +manufacturer?.id)}
                        onChange={(manufacturer) => {
                            setManufacturer(manufacturer);
                            loadData(true, manufacturer)
                        }}
                        options={manufacturers || []}
                        textField="name"
                        valueField="id"
                        menuPlacement="auto"
                        isClearable={true}
                        placeholder={messages['select']}
                    />
                }
                {
                    from === "manufacturer" &&
                    <InputTags
                        tags={tags}
                        setTags={(tags) => {
                            setTags(tags);
                            loadData(true, null, tags)
                        }}
                        valueSearch={valueSearch}
                        setValueSearch={(value) => {
                            setValueSearch(value);
                        }}
                    />
                }
            </Grid>
            <Grid item xs={4} >
                <div style={{ display: 'flex', justifyContent: 'end', marginTop: 20 }}>
                    <IconButton
                        onClick={() => {
                            if (selectedItems?.length > 0) {
                                if (HasPermission(user, "untyev", "d"))
                                    dispatch(unitTypeEventDeleteOpenModal(true, selectedItems))
                                else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['unit_type_events_list_title'],
                                        5000,
                                    );
                                }
                            }
                        }}
                        disabled={selectedItems.length === 0}
                        size="medium">
                        <Icon>delete</Icon>
                    </IconButton>
                    <IconButton
                        onClick={() => {
                            if (HasPermission(user, "untyev", "c"))
                                dispatch(unitTypeEventCreateEditOpenModal(true))
                            else {
                                NotificationManager.warning(
                                    messages['common_error_permission'],
                                    messages['unit_type_events_list_title'],
                                    5000,
                                );
                            }
                        }}
                        size="medium">
                        <Icon>addCircle</Icon>
                    </IconButton>
                </div>
            </Grid>

            <Grid item xs={12}>
                {
                    unitTypeEvents?.map((unitEventType, index) => {

                        let unitType = unitTypes.find(x => x.id === unitEventType.unitTypeId)
                        return (
                            <Card className="mb-2" style={{ marginTop: 10 }} key={index}>
                                <CardContent>
                                    <Grid container direction='row' justifyContent='space-between'>
                                        <Grid item xs={1}>
                                            <Checkbox
                                                id={`${unitEventType.id}`}
                                                value={selectedItems.find(x => x.id === unitEventType.id)}
                                                onChange={(checked) => {
                                                    let items = selectedItems
                                                    if (checked)
                                                        items.push(unitEventType)
                                                    else
                                                        items = selectedItems.filter(x => x.id !== unitEventType.id)

                                                    setSelectedItems([...items])
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={10}>
                                            {
                                                from === "events" &&
                                                <Grid item xs={12}>
                                                    <label>{unitType?.manufacturer?.name}</label>
                                                </Grid>
                                            }
                                            {
                                                from === "manufacturer" &&
                                                <Grid item xs={12}>
                                                    <label style={{ color: `${unitEventType?.event?.color || ""}` }}>{unitEventType?.event?.name}</label>
                                                </Grid>
                                            }
                                            <Grid item xs={12}>
                                                <label>{`${messages["unit_type_events_list_raw_event"]}: ${unitEventType.rawEvent}`}</label>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={1} style={{ justifyContent: 'end' }}>
                                            <MenuComponent
                                                disabled={loading}
                                                options={[
                                                    messages['edit'],
                                                    messages['delete']
                                                ]}
                                                icon={'more_vert'}
                                                className="context-menu"
                                                onClick={(type, value) => {
                                                    if (type === "Edit") {
                                                        if (HasPermission(user, "untyev", "u")) {
                                                            dispatch(unitTypeEventCreateEditOpenModal(true, unitEventType))
                                                        } else {
                                                            NotificationManager.warning(
                                                                messages['common_error_permission'],
                                                                messages['unit_type_events_list_title'],
                                                                5000,
                                                            );
                                                        }
                                                    } else {
                                                        if (HasPermission(user, "untyev", "d")) {
                                                            dispatch(unitTypeEventDeleteOpenModal(true, [unitEventType]))
                                                        } else {
                                                            NotificationManager.warning(
                                                                messages['common_error_permission'],
                                                                messages['unit_type_events_list_title'],
                                                                5000,
                                                            );
                                                        }
                                                    }
                                                }}


                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        )
                    })
                }
            </Grid>
            {CreateEditUnitTypeEventOpenModal && <CreateEditUnitTypeEvent eventParam={event} unitTypeEvents={unitTypeEvents} manufacturerParam={manufacturerParam} unitTypeParam={unitTypeParam} loadData={loadData} />}
            {DeleteUnitTypeEventOpenModal && <DeleteUnitTypeEvent loadData={loadData} />}
        </Grid>
    )
}

export default UnitTypeEventsList;